export const firebaseConfig = {
  apiKey: "AIzaSyBSzu2zDV8zkYlLwtm0xIC0bthMEgOTMuU",
  authDomain: "gocitylive.firebaseapp.com",
  projectId: "gocitylive",
  storageBucket: "gocitylive.appspot.com",
  messagingSenderId: "145023020329",
  appId: "1:145023020329:web:3ee08a4101fe02d3905b38",
  measurementId: "G-E792N88K7B"
};